import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoginService } from './login.service';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  permissions: any = null;

}
